import ProjectEntriesStructureConfigContent from './ProjectEntriesStructureConfigContent'

export default ProjectEntriesStructureConfigContent
